import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.NetSuiteVendorCreationPopupContent.FinancialInformation',
    {
        financialInformationSection: 'Financial information',
        legalName: 'Legal name',
        accountNumber: 'Account number',
        defaultExpenseAccount: 'Default expense account',
        defaultPayablesAccount: 'Default payables account',
        terms: 'Terms',
        creditLimit: 'Credit limit',
        incoterm: 'Incoterm',
        taxNumber: 'Tax id',
        is1099Eligible: 'Is 1099 eligible',
        isJobResource: 'Is job resource',
        inputPlaceholder: 'Enter value',
        selectPlaceholder: 'Select value',
    }
);
